module.exports = __webpack_public_path__ + "img/left-arrow.102ec3ba.svg";